import { render, staticRenderFns } from "./OverseaStudentListPage.vue?vue&type=template&id=27bdaad2&scoped=true"
import script from "./OverseaStudentListPage.vue?vue&type=script&lang=js"
export * from "./OverseaStudentListPage.vue?vue&type=script&lang=js"
import style0 from "./OverseaStudentListPage.vue?vue&type=style&index=0&id=27bdaad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdaad2",
  null
  
)

export default component.exports